import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-dusk"]
const _hoisted_2 = {
  key: 2,
  class: "mt-8"
}
const _hoisted_3 = { class: "space-y-16" }
const _hoisted_4 = { class: "p-10 flex items-center justify-center" }

import { computed, PropType, ref } from 'vue';
import { FormSection } from '@/models';
import SmartFormItem from './SmartFormItem.vue';
import PageLoading from '@/lib/components/Loading/PageLoading.vue';
import { useSmartFormStore } from '@/stores/smartForm.store';
import { stringToDuskAttribute } from '@/custom/menicon/helpers/strings.helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmartFormSection',
  props: {
  section: {
    type: Object as PropType<FormSection>,
    required: true
  },

  patientId: {
    type: String,
    default: null
  },

  participantId: {
    type: String,
    default: null
  },

  formSubmissionId: {
    type: String,
    required: true
  },

  next: {
    type: Function,
    required: true
  },

  back: {
    type: Function,
    required: true
  },

  level: {
    type: Number,
    default: 0
  }
},
  setup(__props) {

const props = __props;




const loadings = ref<string[]>([]);
const smartForm = useSmartFormStore();

const conditionsMet = computed(() => smartForm.getItemConditionsMet(props.formSubmissionId, props.section.conditions));
const duskAttribute = computed(() => props.section.heading ? stringToDuskAttribute(props.section.heading) : 'smart-form-section');

const checkLoading = (event: string) => {
  if (loadings.value.includes(event)) {
    loadings.value.splice(loadings.value.indexOf(event), 1);
  } else {
    loadings.value.push(event);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_SmartFormSection = _resolveComponent("SmartFormSection", true)!

  return (_unref(conditionsMet))
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(["space-y-16", { 'mt-28': __props.level > 0 }]),
        "data-dusk": _unref(duskAttribute)
      }, [
        _createElementVNode("div", null, [
          (__props.section.heading?.length)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent('h' + (__props.level + 1)), {
                key: 0,
                class: _normalizeClass(["font-bold text-gray-900", __props.level === 0 ? 'text-2xl' : 'text-xl'])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.section.heading), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (__props.section.instructions && __props.section.instructions.length)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(["mt-2 text-gray-500", __props.level === 0 ? 'text-lg' : 'text-base'])
              }, _toDisplayString(__props.section.instructions), 3))
            : _createCommentVNode("", true),
          ((__props.section.heading && __props.section.heading.length) || (__props.section.instructions && __props.section.instructions.length))
            ? (_openBlock(), _createElementBlock("hr", _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.section.items, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              (item.type === 'section')
                ? (_openBlock(), _createBlock(_component_SmartFormSection, {
                    key: 0,
                    section: item,
                    "patient-id": __props.patientId,
                    "participant-id": __props.participantId,
                    "form-submission-id": __props.formSubmissionId,
                    next: __props.next,
                    back: __props.back,
                    level: __props.level + 1
                  }, null, 8, ["section", "patient-id", "participant-id", "form-submission-id", "next", "back", "level"]))
                : (_openBlock(), _createBlock(SmartFormItem, {
                    key: item.id,
                    item: item,
                    "patient-id": __props.patientId,
                    "participant-id": __props.participantId,
                    "form-submission-id": __props.formSubmissionId,
                    loading: loadings.value.length !== 0,
                    next: __props.next,
                    back: __props.back,
                    onLoading: checkLoading
                  }, null, 8, ["item", "patient-id", "participant-id", "form-submission-id", "loading", "next", "back"]))
            ], 64))
          }), 128))
        ], 512), [
          [_vShow, loadings.value.length === 0]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createVNode(PageLoading)
        ], 512), [
          [_vShow, loadings.value.length !== 0]
        ])
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})